module.exports = __webpack_public_path__ + "static/media/email.f0e99b45.jpg";